import { useStrictLocalization } from "@faire/web/common/localization";
import React from "react";
import { CloseModalButton, NeedMoreHelpButton, NextStepButton, SubmitButton } from "../components/NavigationButtons";
import { STEP } from "../consts";
import { useLoggedOutContactUsNavigation } from "../hooks/useLoggedOutContactUsNavigation";
import { useLoggedOutEmailTicket } from "../hooks/useLoggedOutEmailTicket";
export var LoggedOutContactUsStepCta = function LoggedOutContactUsStepCta() {
  var _useStrictLocalizatio = useStrictLocalization(),
    strictLocalize = _useStrictLocalizatio.strictLocalize;
  var _useLoggedOutContactU = useLoggedOutContactUsNavigation(),
    nextBtnDisabled = _useLoggedOutContactU.nextBtnDisabled,
    closeModal = _useLoggedOutContactU.closeModal,
    goToNextStep = _useLoggedOutContactU.goToNextStep,
    currentStep = _useLoggedOutContactU.currentStep;
  var _useLoggedOutEmailTic = useLoggedOutEmailTicket(),
    submitTicket = _useLoggedOutEmailTic.submitTicket,
    isLoggedOutSubmitDisabled = _useLoggedOutEmailTic.isLoggedOutSubmitDisabled;
  switch (currentStep) {
    case STEP.LOGGED_OUT_SELECT_TOPIC:
      return /*#__PURE__*/React.createElement(NextStepButton, {
        disabled: nextBtnDisabled(),
        onClick: goToNextStep
      });
    case STEP.HELP_CENTER_ARTICLE:
      return /*#__PURE__*/React.createElement(NeedMoreHelpButton, {
        disabled: nextBtnDisabled(),
        onClick: goToNextStep
      });
    case STEP.CONFIRMATION:
      return /*#__PURE__*/React.createElement(CloseModalButton, {
        onClick: closeModal
      });
    case STEP.LOGGED_OUT_CONTACT_US:
      return /*#__PURE__*/React.createElement(SubmitButton, {
        disabled: isLoggedOutSubmitDisabled(),
        onClick: function onClick() {
          return submitTicket(strictLocalize);
        }
      });
    default:
      return /*#__PURE__*/React.createElement(NextStepButton, {
        disabled: nextBtnDisabled(),
        onClick: goToNextStep
      });
  }
};